import { isEmail } from 'Utils/Validators/email'
import { isOnboardingUrl } from 'Utils/Validators/onboardingUrl'
import { runValidation, isRequired } from 'shared/validation'

const timeRangeError =
  'Bonus check-in window must fall into allowed check-in time range'

const ErrorsMap = {
  recruitmentCalendarId:
    'Invalid communication service id. Should be in a correct email format.',
  eventsCalendarId:
    'Invalid recruitment calendar id. Should be in a correct email format.',
  onboardingUrl: `Invalid Online Meeting URL
  Should be in a correct format. E.g. meet.google.com/aaa-bbbb-ccc`,
  morningCheckInTime: `Invalid check in times.
  The lunch check in time must be greater than the morning check in time.`,
  afternoonCheckInTime: `Invalid check in times.
  The afternoon check in time must be greater than the morning check in time.`,
  lunchCheckInTime: `Invalid check in times.
  The afternoon check in time must be greater than the lunch check in time.`,
  h2hBonusCheckInTimeBefore: timeRangeError,
  h2hBonusCheckInTimeAfter: timeRangeError,
  d2dBonusCheckInTimeBefore: timeRangeError,
  d2dBonusCheckInTimeAfter: timeRangeError,
}

export const validateCityForm = (
  {
    countryId,
    name,
    cbdRadius,
    timezone,
    recruitmentCalendarId,
    eventsCalendarId,
    onboardingUrl,
    morningCheckInTime,
    afternoonCheckInTime,
    lunchCheckInTime,
    h2hBonusCheckInTimeBefore,
    h2hCheckInTimeBefore,
    h2hBonusCheckInTimeAfter,
    h2hCheckInTimeAfter,
    d2dBonusCheckInTimeBefore,
    d2dCheckInTimeBefore,
    d2dBonusCheckInTimeAfter,
    d2dCheckInTimeAfter,
  },
  isEdit,
) => {
  const commonData = {
    name,
    cbdRadius,
    recruitmentCalendarId,
    eventsCalendarId,
    onboardingUrl,
    morningCheckInTime,
    afternoonCheckInTime,
    lunchCheckInTime,
    h2hBonusCheckInTimeBefore,
    h2hCheckInTimeBefore,
    h2hBonusCheckInTimeAfter,
    h2hCheckInTimeAfter,
    d2dBonusCheckInTimeBefore,
    d2dCheckInTimeBefore,
    d2dBonusCheckInTimeAfter,
    d2dCheckInTimeAfter,
  }
  const validationData = isEdit
    ? commonData
    : {
        ...commonData,
        countryId,
        timezone,
      }
  const commonRules = {
    name: isRequired,
    cbdRadius: isRequired,
    recruitmentCalendarId: value => {
      const requiredError = isRequired(value)
      if (requiredError) return requiredError
      return !value || isEmail(value) ? '' : ErrorsMap.recruitmentCalendarId
    },
    eventsCalendarId: value => {
      return !value || isEmail(value) ? '' : ErrorsMap.eventsCalendarId
    },
    onboardingUrl: value => {
      return !value || isOnboardingUrl(value) ? '' : ErrorsMap.onboardingUrl
    },
    morningCheckInTime: value => {
      return value >= lunchCheckInTime ? ErrorsMap.morningCheckInTime : ''
    },
    afternoonCheckInTime: value => {
      return morningCheckInTime >= value ? ErrorsMap.afternoonCheckInTime : ''
    },
    lunchCheckInTime: value => {
      return value >= afternoonCheckInTime ? ErrorsMap.lunchCheckInTime : ''
    },
    h2hBonusCheckInTimeBefore: value => {
      return value > h2hCheckInTimeBefore
        ? ErrorsMap.h2hBonusCheckInTimeBefore
        : ''
    },
    h2hBonusCheckInTimeAfter: value => {
      return value > h2hCheckInTimeAfter
        ? ErrorsMap.h2hBonusCheckInTimeAfter
        : ''
    },
    d2dBonusCheckInTimeBefore: value => {
      return value > d2dCheckInTimeBefore
        ? ErrorsMap.d2dBonusCheckInTimeBefore
        : ''
    },
    d2dBonusCheckInTimeAfter: value => {
      return value > d2dCheckInTimeAfter
        ? ErrorsMap.d2dBonusCheckInTimeAfter
        : ''
    },
  }
  const validationRules = isEdit
    ? commonRules
    : {
        ...commonRules,
        countryId: isRequired,
        timezone: isRequired,
      }
  return runValidation(validationRules, validationData)
}
